import { TablePagination } from 'components/molecules';
import { PaperCardTemplate } from 'components/templates/PaperCardTemplate';


import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useAdminReport } from 'hooks/useAdminReport';
import { AdminReportRow } from 'components/molecules/AdminReport/AdminReportRow';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { formatISO, subDays } from 'date-fns';
import { SelectInput } from 'components/Inputs/SelectInput';
import { DashboardService } from 'services/dashboard.service';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import { Button } from 'components/Button';
import { AdminReportService } from 'services';
import { DialogCheckBox } from 'components/DialogCheckBox';
import { Checkbox } from 'components/Inputs';

export const ReportList: React.FC = () => {
  const {
    docs,
    loading,
    page,
    totalPages,
    handleNextPage,
    handlePreviousPage,
    handleRefresh,
  } = useAdminReport();

  const [startDate, setStartDate] = useState<string | null>(formatISO(subDays(new Date(), 15)));
  const [endDate, setEndDate] = useState<string | null>(formatISO(new Date()));
  const [planId, setPlanId] = useState<string | null>(null);
  const [plans, setPlans] = useState<any>();
  const [url, setFileUrl] = useState<string>();
  const ref = useRef<HTMLAnchorElement | null>(null);
  
  const downloadReport = async () => {
    const _startDate = startDate;
    const data = await AdminReportService.downloadReport(_startDate, endDate, planId);
    const url = URL.createObjectURL(new Blob([data]));
    setFileUrl(url);
    ref.current?.click();
    URL.revokeObjectURL(url);
  }
  const getPlans = async () => {
    const plans = await DashboardService.getPlans();
    setPlans(plans);
  }
  useEffect(() => {
    handleRefresh(startDate, endDate, planId);
    getPlans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate, planId]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <PaperCardTemplate loading={loading}>
        <div style={{display: 'flex', gap: 30, marginBottom: 32 }}>
          <div style={{ width: 700, display: 'flex', gap: 30 }}>
            <DatePicker  label="Data Inicial" onChange={(newValue) => { setStartDate(newValue) }} renderInput={(props) => <TextField  {...props} size='small' helperText={null} />} value={startDate} />
            <DatePicker label="Data Final" onChange={(newValue) => { setEndDate(newValue) }} renderInput={(props) => <TextField  {...props} size='small' helperText={null} />} value={endDate} />
          </div>
      
          <SelectInput
            name="plan"
            id="_id"
            label="Selecione o plano"
            onChange={(event)=> { setPlanId(event.target.value as string) }}
            value={planId}
            defaultValue={planId}
            size='small'
            
          >
            {plans?.map((plan: any) => (
              <MenuItem key={plan._id} value={plan._id}>
                {plan.title}
              </MenuItem> 
            ))}
          </SelectInput>
         <a href={url} className="hidden" download={'relatorio.xlsx'} ref={ref} />
          <Button onClick={downloadReport} disabled={docs.length ? false : true} style={{ maxWidth: 150 }}fullWidth >Baixar relatório </Button>
        </div>
        <Grid display={'flex'} flexDirection={'row'} style={{width: 300}}>
              <Checkbox name="teste" label="Atendidas"/>
              <Checkbox name="teste" label="Não atendidas"/>
        </Grid>
        <Table size="medium" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell component="th" scope="row">
                <Typography fontWeight={500} fontSize={14}>
                  Nome do Tutor
                </Typography>
              </TableCell>

              <TableCell>
                <Typography fontWeight={500} fontSize={14}>
                  Nome do Veterinário
                </Typography>
              </TableCell>

              <TableCell>
                <Typography fontWeight={500} fontSize={14} color="#4B4B4B">
                  Horário do Atendimento
                </Typography>
              </TableCell>

              <TableCell align="left" width={85}>
                <Typography fontWeight={500} fontSize={14}>
                  Motivo
                </Typography>
              </TableCell>

              <TableCell align="center" width={50}>
                <Typography fontWeight={500} fontSize={14}>
                  Avaliação
                </Typography>
              </TableCell>

              <TableCell align="left" width={50}>
                <Typography fontWeight={500} fontSize={14}>
                  Duração
                </Typography>
              </TableCell>

              <TableCell align="left" width={50}>
                <Typography fontWeight={500} fontSize={14}>
                  Espera
                </Typography>
              </TableCell>

              <TableCell align="left" width={50}>
                <Typography fontWeight={500} fontSize={14}>
                  Atendida
                </Typography>
              </TableCell>

              
            </TableRow>
          </TableHead>

          {docs?.length < 1 && (
            <Typography component="caption">
              <Box textAlign="center">
                Não há dados de atendimento para as datas selecionadas
              </Box>
            </Typography>
          )}

          <TableBody>
            {docs?.map((reports, index) => (
              <AdminReportRow key={index} adminReport={reports} />
            ))}
          </TableBody>
        </Table>      
        <TablePagination
          currentPage={page}
          maxPage={totalPages}
          onPreviousClick={handlePreviousPage}
          onNextClick={handleNextPage}
        />
      </PaperCardTemplate>
    </LocalizationProvider>
  );
};


